import { useState, useContext } from "react";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ProfileContainer.styles.css";
import { ReactComponent as ProfileBannerIcon } from "../../assets/images/profile/icon.svg";
import ProfileBanner from "../../assets/images/profile/event_bg.jpg";
import { useDispatch, useSelector } from "react-redux";
import ChangePasswordForm from "../../components/auth/ChangePassword.component";
import PersonalDetailsForm from "../../components/profile-form/PersonalDetailsForm.component";
import MfaSetting from "../../components/profile-form/MfaSetting.component";
import BreadcrumbContextApi from "../../context/BreadcrumbContextApi.context";
import useWindowSize from "../../hooks/useWindowSize";
import CustomSideModal from "../../components/global/CustomSideModal.component";
import { useSearchParams } from "react-router-dom";
import MfaForm from "../../components/auth/MfaForm.component";
import axios from "axios";
import { getApiUrl } from "../../utils/apiUrls";
import { apiErrorHandler } from "../../utils/errorHandler";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { logout, modifyName } from "../../redux/actions/user.actions";
import { inputValidation, replaceDynamicString } from "../../utils/helperFn";
import CustomInput from "../../components/global/CustomInput.component";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component";
import instance from "../../utils/axios";
import MfaFormDialogContainer from "./MfaFormDialog.container";

const tableOfContent = [
  { label: "credentials", value: 0 },
  { label: "personal_details", value: 1 },
  { label: "mfa_settings", value: 2 },
];

const ProfileContainer = ({ t }) => {
  const windowSize = useWindowSize();
  const user = useSelector((state) => state.user);
  const [tabValue, setTabValue] = useState(0);
  const { modalIsOpen, modalIsOpenHander } = useContext(BreadcrumbContextApi);
  const [editNameData, setEditNameData] = useState({
    status: false,
    isLoading: false,
    firstName: {
      value: user.firstName || '',
      msg: null,
    },
    middleName: {
      value: user.middleName || '',
      msg: null,
    },
    lastName: {
      value: user.lastName || '',
      msg: null,
    },
    originalName: {
      firstName: user.firstName,
      middleName: user.middleName,
      lastName: user.lastName,
    }
  })

  const dispatch = useDispatch();
   const appSettingLang = useSelector(state => state.lang);
  const [searchParams] = useSearchParams();
  const refId = searchParams.get("refId");
  const getLang = searchParams.get("lang");
  const clientData = useSelector((state) => state.clientData);
  const [mfadata, setMfadata] = useState({
      viaEmail: false,
      isUpdateNameLoading: true,
      isChangePasswordLoading: true,
      viaAuthenticator: false,
      defaultAuthenticationTypeFlag: false,
      emailId: null,
      qrIsSet: false,
      type: "",
      otp: Array(6).fill(""),
      otpHasErrorMsg: "",
      originalAuthenticationType: "",
      isBackButtonStr: "",
      backButtonHistory: {
        type: "",
        defaultAuthenticationTypeFlag: "",
      },
  });

  const [dialogMfaData, setDialogMfaData] = useState({
    dialogStatus: false,
    dialogType: null,
    dialogHeading: null,
    viaEmail: false,
    viaAuthenticator: false,
    defaultAuthenticationTypeFlag: false,
    emailId: null,
    qrIsSet: false,
    type: "",
    otp: Array(6).fill(""),
    otpHasErrorMsg: "",
    originalAuthenticationType: "",
  })

  const [finalData, setFinalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleDialogMfaDataChange = (dataToUpdate={}) => {
    setDialogMfaData((prevData) => ({
      ...prevData,
      ...dataToUpdate,
    }));
  }

  const handleResetDialogMfaData = () => {
    setDialogMfaData({
      dialogStatus: false,
      dialogType: null,
      dialogHeading: null,
      viaEmail: false,
      viaAuthenticator: false,
      defaultAuthenticationTypeFlag: false,
      emailId: null,
      qrIsSet: false,
      type: "",
      otp: Array(6).fill(""),
      otpHasErrorMsg: "",
      originalAuthenticationType: "",
    });
    setIsLoading(false);
  }

  const authenticationTypeValue = () => {
    if (mfadata.viaAuthenticator && mfadata.viaEmail) {
      return "EMAIL_AND_AUTHENTICATION_APP";
    } else if (mfadata.viaEmail) {
      return "EMAIL";
    } else {
      return "AUTHENTICATION_APP";
    }
  };

  const skipForNowHandler = () => {
    submitHandler({ authenticationType: null, username: mfadata.emailId, }, 1);
  };

  const actionHandler = (val = null) => {
    if (val === "RESEND_OTP") {
        submitHandler(
            {
                authenticationType: "EMAIL",
                username: mfadata.emailId,
                resend: true,
            },
            2,
            null,
            "RESEND_OTP"
        );

        return;
    }
    const passCode = Number(
        mfadata.otp[0] +
            mfadata.otp[1] +
            mfadata.otp[2] +
            mfadata.otp[3] +
            mfadata.otp[4] +
            mfadata.otp[5]
    );
    switch (mfadata.type) {
        case "FIRST_TIME_LOGIN":
            submitHandler(
                {
                    authenticationType: authenticationTypeValue(),
                    username: mfadata.emailId,
                },
                1
            );
            break;
        case "FIRST_STEP":
            submitHandler(
                {
                    username: mfadata.emailId,
                    defaultAuthentication: mfadata.defaultAuthenticationTypeFlag,
                    authenticationType: mfadata.viaEmail
                    ? "EMAIL"
                    : "AUTHENTICATION_APP",
                },
                2,
                {
                    type: mfadata.viaEmail ? "SECOND_STEP_EMAIL" : "SECOND_STEP_APP",
                }
            );
            break;
        case "SECOND_STEP_EMAIL":
            if (passCode.toString().length !== 6) {
                setMfadata({
                    ...mfadata,
                    otpHasErrorMsg: "opt_should_have_six_number",
                });
                return;
            }
            submitHandler(
                {
                    actionType: "EMAIL",
                    username: mfadata.emailId,
                    passCode: Number(passCode),
                },
                3
            );
            break;
        case "SECOND_STEP_APP":
            if (passCode.toString().length !== 6) {
                setMfadata({
                    ...mfadata,
                    otpHasErrorMsg: "opt_should_have_six_number",
                });
                return;
            }
            submitHandler(
                {
                    actionType: "AUTHENTICATION_APP",
                    username: mfadata.emailId,
                    passCode: Number(passCode),
                },
                3
            );
            break;
        default: return null
    }
  };
  const dialogActionHandler = (val = null) => {
    if (val === "RESEND_OTP") {
        mfaDialogSubmitHandler(
            {
                authenticationType: "EMAIL",
                username: mfadata.emailId,
                resend: true,
            },
            2,
            null,
            "RESEND_OTP"
        );

        return;
    }
    const passCode = Number(
        dialogMfaData.otp[0] +
            dialogMfaData.otp[1] +
            dialogMfaData.otp[2] +
            dialogMfaData.otp[3] +
            dialogMfaData.otp[4] +
            dialogMfaData.otp[5]
    );
    switch (dialogMfaData.type) {
        case "FIRST_TIME_LOGIN":
            mfaDialogSubmitHandler(
                {
                    authenticationType: authenticationTypeValue(),
                    username: dialogMfaData.emailId,
                },
                1
            );
            break;
        case "FIRST_STEP":
            mfaDialogSubmitHandler(
                {
                    username: dialogMfaData.emailId,
                    defaultAuthentication: dialogMfaData.defaultAuthenticationTypeFlag,
                    authenticationType: dialogMfaData.viaEmail
                    ? "EMAIL"
                    : "AUTHENTICATION_APP",
                },
                2,
                {
                    type: dialogMfaData.viaEmail ? "SECOND_STEP_EMAIL" : "SECOND_STEP_APP",
                }
            );
            break;
        case "SECOND_STEP_EMAIL":
            if (passCode.toString().length !== 6) {
                setDialogMfaData({
                    ...dialogMfaData,
                    otpHasErrorMsg: "opt_should_have_six_number",
                });
                return;
            }
            mfaDialogSubmitHandler(
                {
                    actionType: "EMAIL",
                    username: dialogMfaData.emailId,
                    passCode: Number(passCode),
                },
                3
            );
            break;
        case "SECOND_STEP_APP":
            if (passCode.toString().length !== 6) {
                setDialogMfaData({
                    ...dialogMfaData,
                    otpHasErrorMsg: "opt_should_have_six_number",
                });
                return;
            }
            mfaDialogSubmitHandler(
                {
                    actionType: "AUTHENTICATION_APP",
                    username: dialogMfaData.emailId,
                    passCode: Number(passCode),
                },
                3
            );
            break;
        default: return null
    }
  };
  const mfadataHandler = (val) => {
      setMfadata({ ...mfadata, ...val });
  };

  const submitHandler = async (
    data,
    stepper,
    appendMfaData = null,
    actionType
  ) => {
    try {
        if (isLoading) return;
        setIsLoading("CHANGE_PASSWORD");
        const token = localStorage.getItem('token');

        const dataToSend = {
          ...data, refId, getLang, mettlClientName: clientData?.clientName ? clientData?.clientName : null
        }

        const loginData = await axios.post(
            `${getApiUrl("changePasswordMfaCheck")}?stepper=${stepper}`,
            dataToSend,
            { headers: {"Authorization" : `Bearer ${token}`,} }
        );
        if(stepper === 0) setFinalData(data);
        // const loginData = {
        //     data: {
        //         "authenticationRequired": true,
        //         "defaultAuthenticationType": null,
        //         "mfaDate": 1749686400,
        //         "authenticationType": null,
        //         "candidateId": 233
        //     }
        // }
        if (stepper === 0) {
            // WHEN USER WRITE EMAIL AND PASSWORD
            let type;
            let temp = {};
            if (loginData.data.authenticationType === null) {
                type = "FIRST_TIME_LOGIN";
            } else if (
                loginData.data.authenticationType === "EMAIL" ||
                loginData.data.defaultAuthenticationType === "EMAIL"
            ) {
                submitHandler(
                    {
                        defaultAuthentication:
                            !!loginData?.data?.defaultAuthenticationType,
                        authenticationType: "EMAIL",
                        username: data.username,
                    },
                    2
                );
                temp = { viaEmail: true };
                type = "SECOND_STEP_EMAIL";
            } else if (
                loginData.data.authenticationType === "AUTHENTICATION_APP" ||
                loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
            ) {
                temp = { viaAuthenticator: true };
                type = "SECOND_STEP_APP";
            } else if (loginData.data.authenticationType === "EMAIL_AND_AUTHENTICATION_APP") {
                type = "FIRST_STEP";
            }
            if (loginData.data.defaultAuthenticationType === "EMAIL") {
                temp = { viaEmail: true };
            } else if (
                loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
            ) {
                temp = { viaAuthenticator: true };
            }
            setMfadata({
                ...mfadata,
                mfaDate: loginData.data.mfaDate,
                defaultAuthenticationType: loginData.data.defaultAuthenticationType,
                defaultAuthenticationTypeFlag:
                    !!loginData.data.defaultAuthenticationType,
                originalAuthenticationType: loginData.data.authenticationType,
                emailId: data.username,
                candidateId: loginData.data.candidateId,
                type,
                ...temp,
            });
        }
        if (stepper === 2) {
            if (!!appendMfaData) {
                setMfadata({
                    ...mfadata,
                    ...appendMfaData,
                });
            } else if (actionType === "RESEND_OTP") {
                dispatch(
                    openSnackBar({
                    msg: t("resend_otp_send_sucessfully"),
                    type: "success",
                    })
                );
            }
        }
        if(stepper === 3 || (stepper === 0 && (loginData.data.authenticationRequired === false && loginData.data.authenticationType === null))) {
          const res = await axios.post(getApiUrl('changePassword'), stepper === 0 ? data : finalData, {
              headers: {
                  "Authorization" : `Bearer ${token}`,
              }
          });
  
          if(res.data.status === "SUCCESS") {
              setIsLoading(false);
              dispatch(openSnackBar({
                  msg: t(res.data.message),
                  type: 'success'
              }));

              setTimeout(() => {
                  dispatch(logout(appSettingLang, refId));
              }, 2000);
          } else {
              throw Error(res.data);
          }
        }
        setIsLoading(false);
    } catch (err) {
        setIsLoading(false);
        const errObj = apiErrorHandler(err);
        if (stepper === 0) {
            if (errObj.statusText === "account_not_activated") {
                dispatch(
                    openSnackBar({
                    msg: t("account_not_activated"),
                    type: "error",
                    })
                );
                return;
            }
        } else if (stepper === 3) {
            if(errObj.statusText === "otp_invalid") {
              setMfadata({
                  ...mfadata,
                  otpHasErrorMsg: "invalid_passcode_please_try_again",
              });
              dispatch(
                  openSnackBar({
                      msg: t("invalid_passcode_please_try_again"),
                      type: "error",
                  })
              );
            } else {
              dispatch(openSnackBar({
                  msg: t(errObj.statusText),
                  type: 'error'
              }));
              setMfadata({
                  viaEmail: false,
                  viaAuthenticator: false,
                  defaultAuthenticationTypeFlag: false,
                  emailId: null,
                  qrIsSet: false,
                  type: "",
                  otp: Array(6).fill(""),
                  otpHasErrorMsg: "",
                  originalAuthenticationType: "",
                  isBackButtonStr: "",
                  backButtonHistory: {
                      type: "",
                      defaultAuthenticationTypeFlag: "",
                  },
              });
              setFinalData(null);
          }
            return;
        } else if (errObj.statusText === "otp_already_send") {
            dispatch(
                openSnackBar({
                    msg: t("resend_otp_send_sucessfully"),
                    type: "success",
                })
            );
            return;
        }
        if (err.response?.data?.status === 401) {
            dispatch(
                openSnackBar({
                    msg: t(err.response.data.details[0]),
                    type: "error",
                })
            );
        } else {
            dispatch(
                openSnackBar({
                    msg: t(errObj.statusText),
                    type: "error",
                })
            );
        }
    }
  };

  const mfaDialogSubmitHandler = async (
    data,
    stepper,
    appendMfaData = null,
    actionType
  ) => {
    try {
      if (isLoading) return;
      setIsLoading(data?.dialogType || dialogMfaData?.dialogType || true);
      const token = localStorage.getItem('token');

      const dataToSend = {
        ...data, refId, getLang, mettlClientName: clientData?.clientName ? clientData?.clientName : null
      }

      const loginData = await instance.post(
          `${getApiUrl("changePasswordMfaCheck")}?stepper=${stepper}`,
          dataToSend,
          { headers: {"Authorization" : `Bearer ${token}`,} }
      );
      if(stepper === 0) setFinalData(data);
      // const loginData = {
      //     data: stepper === 0 ? {
      //         "authenticationRequired": false,
      //         "defaultAuthenticationType": null,
      //         "mfaDate": 1749686400,
      //         "authenticationType": null,
      //         "candidateId": user.candidateId
      //     } : "email_otp_send_successfully"
      // }
      if (stepper === 0) {
          // WHEN USER WRITE EMAIL AND PASSWORD
          let type;
          let temp = {};
          if(loginData.data.authenticationRequired === true && loginData.data.authenticationType === null) {
            dispatch(
              openSnackBar({
                msg: t("enable_atleast_one_multi_factor_authentication"),
                type: "info",
              })
            );
            setTabValue(2);
            setEditNameData({ ...editNameData, status: false });
            return;
          }
          if (
              loginData.data.authenticationType === "EMAIL" ||
              loginData.data.defaultAuthenticationType === "EMAIL"
          ) {
              mfaDialogSubmitHandler(
                  {
                    defaultAuthentication: !!loginData?.data?.defaultAuthenticationType,
                    authenticationType: "EMAIL",
                  },
                  2
              );
              temp = { viaEmail: true };
              type = "SECOND_STEP_EMAIL";
          } else if (
              loginData.data.authenticationType === "AUTHENTICATION_APP" ||
              loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
          ) {
              temp = { viaAuthenticator: true };
              type = "SECOND_STEP_APP";
          } else if (loginData.data.authenticationType === "EMAIL_AND_AUTHENTICATION_APP") {
            type = "FIRST_STEP";
          }
         
          setDialogMfaData((prevState) => ({
              ...prevState,
              mfaDate: loginData.data.mfaDate,
              defaultAuthenticationType: loginData.data.defaultAuthenticationType,
              defaultAuthenticationTypeFlag:
                  !!loginData.data.defaultAuthenticationType,
              originalAuthenticationType: loginData.data.authenticationType,
              emailId: data.username,
              candidateId: loginData.data.candidateId,
              type,
              ...(data.dialogType && stepper === 0 && loginData.data.authenticationRequired ? {dialogStatus: true} : {}),
              ...(data.dialogType && stepper === 0 && loginData.data.authenticationRequired ? { dialogType: data.dialogType, dialogHeading: data.dialogHeading, emailId: user.userEmail } : {}),
              ...temp,
          }));
      }
      if (stepper === 2) {
          if (!!appendMfaData) {
              setDialogMfaData({
                  ...dialogMfaData,
                  ...appendMfaData,
              });
          } else if (actionType === "RESEND_OTP") {
              dispatch(
                  openSnackBar({
                    msg: t("resend_otp_send_sucessfully"),
                    type: "success",
                  })
              );
          }
      }
      if(stepper === 3 || (stepper === 0 && (loginData.data.authenticationRequired === false && loginData.data.authenticationType === null))) {
        const dialogType = stepper === 0 ? data.dialogType : dialogMfaData.dialogType;
        const endPoint = dialogType === "CHANGE_PASSWORD" ? 'changePassword' : 'updateName';
        const finalDataToSend = dialogType === "CHANGE_PASSWORD" ? stepper === 0 ? data : finalData : {
          firstName: editNameData.firstName.value?.trim(),
          middleName: editNameData.middleName.value?.trim(),
          lastName: editNameData.lastName.value?.trim(),
        }
        
        const res = await instance.post(getApiUrl(endPoint), finalDataToSend, {
            headers: {
              "Authorization" : `Bearer ${token}`,
            }
        });

        if(res.data.status === "SUCCESS") {
            setIsLoading(false);
            dispatch(openSnackBar({
                msg: t(res.data.message),
                type: 'success'
            }));

            if(dialogType === "CHANGE_PASSWORD") {
              setTimeout(() => {
                dispatch(logout(appSettingLang, refId));
              }, 2000);
            }
            if(dialogType === "UPDATE_NAME") {
              dispatch(modifyName(finalDataToSend));
              if(res.data?.message) {
                dispatch(openSnackBar({
                  msg: t(res.data.message),
                  type: 'success'
                }));
              }
              setEditNameData({ ...editNameData, status: false, originalName: finalDataToSend });
            }

            setDialogMfaData((prevState) => ({
              ...prevState,
              dialogStatus: false,
              dialogType: null, 
              dialogHeading: null, 
              emailId: null,
              viaEmail: false,
              viaAuthenticator: false,
              defaultAuthenticationTypeFlag: false,
              qrIsSet: false,
              type: "",
              otp: Array(6).fill(""),
              otpHasErrorMsg: "",
              originalAuthenticationType: "",
              isBackButtonStr: "",
              backButtonHistory: {
                type: "",
                defaultAuthenticationTypeFlag: "",
              },
          }));

        } else {
            throw Error(res.data);
        }
      }
      setIsLoading(false);
  } catch (err) {
      setIsLoading(false);
      const errObj = apiErrorHandler(err);
      if (stepper === 0) {
          if (errObj.statusText === "account_not_activated") {
              dispatch(
                  openSnackBar({
                  msg: t("account_not_activated"),
                  type: "error",
                  })
              );
              return;
          }
      } else if (stepper === 3) {
          if(errObj.statusText === "otp_invalid") {
            setDialogMfaData({
                ...dialogMfaData,
                otpHasErrorMsg: "invalid_passcode_please_try_again",
            });
            dispatch(
                openSnackBar({
                    msg: t("invalid_passcode_please_try_again"),
                    type: "error",
                })
            );
          } else {
            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }));
            setDialogMfaData({
                viaEmail: false,
                viaAuthenticator: false,
                defaultAuthenticationTypeFlag: false,
                emailId: null,
                qrIsSet: false,
                type: "",
                otp: Array(6).fill(""),
                otpHasErrorMsg: "",
                originalAuthenticationType: "",
                isBackButtonStr: "",
                backButtonHistory: {
                    type: "",
                    defaultAuthenticationTypeFlag: "",
                },
            });
            setFinalData(null);
        }
          return;
      } else if (errObj.statusText === "otp_already_send") {
          dispatch(
              openSnackBar({
                  msg: t("resend_otp_send_sucessfully"),
                  type: "success",
              })
          );
          return;
      }
      if (err.response?.data?.status === 401) {
          dispatch(
              openSnackBar({
                  msg: t(err.response.data.details[0]),
                  type: "error",
              })
          );
      } else {
          dispatch(
              openSnackBar({
                  msg: t(errObj.statusText),
                  type: "error",
              })
          );
      }
    }
  };

  const subTextHandler = () => {
      if (!!mfadata?.type && mfadata.type === "FIRST_TIME_LOGIN") {
      return t("choose_set_multi_factor_authentication");
      }
      if (
      !!mfadata?.type &&
      (mfadata.type === "SECOND_STEP_EMAIL" ||
          mfadata.type === "SECOND_STEP_APP" ||
          mfadata.type === "FIRST_STEP")
      ) {
      return t("mfa_verification_method");
      }
      return t("login_into_your_account");
  };

  const formComponent = () => {
    switch (tabValue) {
      case 0:
        return (
          <div className="cm-personal-details-wrap">
            {!mfadata?.type ? <>
              <p className="cm-personal-details-head cm-sm-txt text-blue-gray-500 my-0">
                {t("credentials")}
              </p>
              <ChangePasswordForm t={t} user={user} submitHandler={(data, stepper, appendMfaData, actionType) => mfaDialogSubmitHandler({ ...data, dialogType: "CHANGE_PASSWORD" }, stepper, appendMfaData, actionType)} isParentLoading={isLoading === "CHANGE_PASSWORD"} />
            </> : <MfaForm
              actionHandler={actionHandler}
              mfadata={mfadata}
              mfadataHandler={mfadataHandler}
              skipForNowHandler={skipForNowHandler}
          />}
          </div>
        );
      case 1:
        return (
          <div className="cm-personal-details-wrap">
            <p className="cm-personal-details-head cm-sm-txt text-blue-gray-500 my-0">
              {t("personal_details")}
            </p>
            <PersonalDetailsForm t={t} user={user} />
          </div>
        );
      default:
        return <MfaSetting t={t} user={user} />;
    }
  };

  const handleEditNameChange = (key, value) => {
    setEditNameData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        msg: null,
        value: value,
      },
    }));
  }

  const handleSaveName = async () => {
    try {
      const res = await instance.post(getApiUrl('updateName'), {
        firstName: editNameData.firstName.value,
        middleName: editNameData.middleName.value,
        lastName: editNameData.lastName.value,
      });
      if(res.data.status === "SUCCESS") {
        setEditNameData({ ...editNameData, status: false });  
      }
    } catch (error) {
      const msgObj = apiErrorHandler(error);
      dispatch(openSnackBar({
        message: msgObj.message,
        severity: "error",
        isLoading: false,
      }));
    }
  }

  return (
    <div className="cm-profile-wrapper d-md-flex">
      <div
        className={`cm-profile-sidebar position-absolute bg-blue-gray-50 ${
          windowSize.isMobile ? "" : "py-4 px-40"
        }`}
      >
        <p className="fw-medium text-blue-gray-500 cm-sm-txt">
          {t("table_of_content")}
        </p>
        <p className="mb-1 cm-sm-txt text-blue-gray-700 fw-medium cm-btn-radius bg-blue-gray-50 cm-profile-sidebar-sh border border-blue-gray-100 py-2 px-3">
          {t("overview")}
        </p>
        <ul className="ps-20 mt-3">
          <li
            onClick={() => setTabValue(0)}
            className={`mt-2 d-flex align-items-center border bg-white py-2 px-3 mb-2 user-select-none rounded ${
              tabValue === 0
                ? "cm-pointer-none text-blue-500 border-blue-500"
                : "cm-pointer text-blue-gray-700 border-blue-gray-100"
            }`}
          >
            <span className="cm-sm-txt fw-medium">{t("credentials")}</span>
          </li>
          <li
            onClick={() => setTabValue(1)}
            className={`d-flex align-items-center border bg-white py-2 px-3 rounded ${
              tabValue === 1
                ? "cm-pointer-none text-blue-500 border-blue-500"
                : "cm-pointer text-blue-gray-700 border-blue-gray-100"
            }`}
          >
            <span className="cm-sm-txt fw-medium">{t("personal_details")}</span>
          </li>
          <li
            onClick={() => setTabValue(2)}
            className={`mt-2 d-flex align-items-center border bg-white py-2 px-3 mb-2 user-select-none rounded ${
              tabValue === 2
                ? "cm-pointer-none text-blue-500 border-blue-500"
                : "cm-pointer text-blue-gray-700 border-blue-gray-100"
            }`}
          >
            <span className="cm-sm-txt fw-medium">{t("mfa_settings")}</span>
          </li>
        </ul>
      </div>
      <div className="cm-profile-content-wrap bg-white">
        {tabValue !== 2 && (
          <div className="cm-profile-content-wrap-header bg-white">
            <div className="cm-profile-banner position-relative">
              <img src={ProfileBanner} alt="Profile" />
              <span className="cm-banner-user-icon d-flex align-items-center justify-content-center">
                <ProfileBannerIcon />
              </span>
            </div>
            <MfaFormDialogContainer handleDialogMfaDataChange={handleDialogMfaDataChange} t={t} dialogMfaData={dialogMfaData} handleResetDialogMfaData={handleResetDialogMfaData} actionHandler={dialogActionHandler} />
            <div className="cm-profile-info">
              {!editNameData.status ? <h4 className="fw-bold text-blue-700 cm-mmc-font">
                {user.firstName} {!!user.middleName ? user.middleName : ""}{" "}
                {!!user.lastName ? user.lastName : ""}
                <FontAwesomeIcon icon={regular("edit")} className="cm-xs-txt ps-2 text-blue-gray-500 cm-pointer" onClick={() => setEditNameData({ ...editNameData, status: true })} />
              </h4> : <div className="d-flex mb-2">
                <div className="col-sm-3 pe-2">
                  <label className="cm-sm-txt fw-medium text-blue-gray-700 mb-2">{t("first_name")}</label>
                  <CustomInput
                    inputClass={`w-100`}
                    type="text"
                    hasError={Boolean(editNameData?.firstName?.msg)}
                    disabled={false}
                    onChange={(e) => {
                      handleEditNameChange("firstName", e.target.value);
                    }}
                    msg={t(editNameData?.firstName?.msg)}
                    value={editNameData?.firstName.value}
                  />
                </div>
                <div className="col-sm-3 px-2">
                  <label className="cm-sm-txt fw-medium text-blue-gray-700 mb-2">{t("middle_name")}</label>
                  <CustomInput
                    inputClass={`w-100`}
                    type="text"
                    hasError={Boolean(editNameData?.middleName?.msg)}
                    disabled={false}
                    onChange={(e) => {
                      handleEditNameChange("middleName", e.target.value);
                    }}
                    msg={t(editNameData?.middleName?.msg)}
                    value={editNameData?.middleName.value}
                  />
                </div>
                <div className="col-sm-3 px-2">
                  <label className="cm-sm-txt fw-medium text-blue-gray-700 mb-2">{t("last_name")}</label>
                  <CustomInput
                    inputClass={`w-100`}
                    type="text"
                    hasError={Boolean(editNameData?.lastName?.msg)}
                    disabled={false}
                    onChange={(e) => {
                      handleEditNameChange("lastName", e.target.value);
                    }}
                    msg={t(editNameData?.lastName?.msg)}
                    value={editNameData?.lastName.value}
                  />
                </div>
                <div className="d-flex ps-3" style={{ marginTop: "30px" }}>
                  <CustomButtonLoader
                    showLoadingState={isLoading === "UPDATE_NAME"}
                    disabled={
                      editNameData.firstName.value.trim() === (editNameData.originalName.firstName || '').trim() &&
                      editNameData.middleName.value.trim() === (editNameData.originalName.middleName || '').trim() &&
                      editNameData.lastName.value.trim() === (editNameData.originalName.lastName || '').trim()
                    }
                    icon={null}
                    buttonLabel={t("update")}
                    colorTheme={"hoverBlue"}
                    buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
                    handleOnClick={() => {
                      const firstNameMsg = inputValidation(
                        editNameData.firstName.value.trim(),
                        true,
                        100,
                        t("input_field_required"),
                        replaceDynamicString(t("maximum_limit_input_field"), [t("first_name")]),
                        "regexA",
                        t("invalid_format_name")
                      );
                      const middleNameMsg = inputValidation(
                        editNameData.middleName.value.trim(),
                        false,
                        100,
                        t("input_field_required"),
                        replaceDynamicString(t("maximum_limit_input_field"), [t("middle_name")]),
                        "regexA",
                        t("invalid_format_name")
                      );
                      const lastNameMsg = inputValidation(
                        editNameData.lastName.value.trim(),
                        false,
                        100,
                        t("input_field_required"),
                        replaceDynamicString(t("maximum_limit_input_field"), [t("last_name")]),
                        "regexA",
                        t("invalid_format_name")
                      );
                      if (firstNameMsg || middleNameMsg || lastNameMsg) {
                        setEditNameData({
                          ...editNameData,
                          firstName: { ...editNameData.firstName, msg: firstNameMsg },
                          middleName: { ...editNameData.middleName, msg: middleNameMsg },
                          lastName: { ...editNameData.lastName, msg: lastNameMsg },
                        });
                        return;
                      }
                      mfaDialogSubmitHandler({dialogType: "UPDATE_NAME", dialogHeading: t("update_name")}, 0);
                    }}
                  />
                  <CustomButtonLoader
                    showLoadingState={false}
                    disabled={false}
                    icon={null}
                    buttonLabel={t(`cancel`)}
                    colorTheme={"white"}
                    buttonStyle={"ms-2 py-2 px-3 cm-mar-left-icon fw-medium"}
                    handleOnClick={() => {
                      setEditNameData({ ...editNameData, status: false });
                    }}
                  />
                </div>
              </div>}
              <p className="d-flex align-items-center text-blue-gray-500 cm-sm-txt my-0">
                <FontAwesomeIcon icon={regular("envelope")} />
                <span className="ps-2">{user.userEmail}</span>
              </p>
            </div>
          </div>
        )}
        {formComponent()}
      </div>
      <CustomSideModal
        t={t}
        title={t("table_of_contents")}
        width={1016}
        buttonArrayData={null}
        subTitle={null}
        isOpen={modalIsOpen}
        closeModal={() => modalIsOpenHander()}
      >
        <div className="px-2 pt-1">
          {tableOfContent.map((el) => (
            <p
              className={`px-2 py-10 mb-1 fw-medium cm-sm-txt ${
                el.value === tabValue
                  ? "bg-blue-gray-50 text-action-blue"
                  : "text-blue-800 cm-pointer"
              }`}
              onClick={() => {
                setTabValue(el.value);
                modalIsOpenHander();
              }}
            >
              {t(el.label)}
            </p>
          ))}
        </div>
      </CustomSideModal>
    </div>
  );
};

export default ProfileContainer;
